import firebase from "firebase";
import netpack from "./../utils/netpack";
import actionConsts from "../constants/actions";
import urlConsts from "../constants/urls";
import {
    setCurrentTime,
    startTimer,
    setTotalSimTime,
    stopTimer
} from "./timer";
import { scheduleMails } from "./mail/mailScheduler";
import store from "./../store/store";

const getStartingTimeFromFirebaseDB = (
    response,
    isTutorial,
    dispatch,
    getState
) => {
    let userDetails = response.user,
        gameDuration = response.config.game.duration;
    let firebasedbref = firebase
        .database()
        .ref("group/" + userDetails.groupId + "/user/" + userDetails.uliId);
    if (isTutorial) {
        firebasedbref = firebase
            .database()
            .ref(
                "group/" +
                userDetails.groupId +
                "/user/" +
                userDetails.uliId +
                "/tutorial/"
            );
        gameDuration = 240;
    }
    let timeObj = {};
    firebasedbref
        .once("value", function (doc) {
            timeObj = getTotalTimeForNewUser(gameDuration);
            if (!isTutorial) {
                if (doc.exists() && doc.val().timeLeft >= 0) {
                    //if time is set for tutorial
                    timeObj = doc.val();
                }
            }
            dispatch(setTotalSimTime(gameDuration));
            dispatch(setCurrentTime(timeObj));
        })
        .then(() => {
            scheduleMails(response, dispatch, getState);
            if (!isTutorial) {
                startTimer(userDetails, isTutorial, timeObj.timeLeft, dispatch);
            }
        });
};

const getTotalTimeForNewUser = gameDuration => {
    return { timeLeft: gameDuration };
};

export const getFireBaseToken = () => {
    return netpack(urlConsts.GET_FIREBASE_TOKEN)
        .get()
        .then(response => {
            return response
        })
}

const checkFirebaseConnection = () => {
    //for now just stopping the timer on header, other bg actions still continue running
    let connectedRef = firebase.database().ref(".info/connected");
    connectedRef.on("value", function (snap) {
        if (!snap.val()) {
            alert("network error");
            stopTimer();
        }
    });
};

export const updateFirebaseData = (userDetails, isTutorial, timeLeft) => {
    checkFirebaseConnection();
    if (!isTutorial) {
        firebase
            .database()
            .ref("group/" + userDetails.groupId + "/user/" + userDetails.uliId)
            .set({
                timeLeft
            });
    }
    else {
        firebase
            .database()
            .ref(
                "group/" +
                userDetails.groupId +
                "/user/" +
                userDetails.uliId +
                "/tutorial/"
            )
            .set({
                timeLeft
            });
    }
};

export const connectToFireBase = (
    response,
    isTutorial = false,
    dispatch,
    getState
) => {
    if (!firebase.apps.length) {
        firebase.initializeApp(response.config.firebase);
    }
    getFireBaseToken().then((firebaseTokenResp) => {
        firebase.auth().signInWithCustomToken(firebaseTokenResp.firebaseToken).
            then(getStartingTimeFromFirebaseDB(response, isTutorial, dispatch, getState))
    })
};



// WEBPACK FOOTER //
// /src/actions/firebase.js